import { createAction } from '@ngrx/store';

export const AppInit = createAction('[App] Init');
